import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: '/services/plugin-live-multi-company/user/'
})

const listUsersApi = companyID => {
    return axiosInstance.get('', { params: { companyID } })
}

const createUserApi = user => {
    return axiosInstance.post('', user)
}

const updateUserApi = user => {
    return axiosInstance.put(`/${user.id}`, user)
}
export { listUsersApi, createUserApi, updateUserApi }
